// extracted by mini-css-extract-plugin
export default {"results_footer":"baa","hide_img":"caa","img":"eaa","copy_wrapper":"faa","grid":"gaa","grid_item":"haa"};
    if(module.hot) {
      // 1715632479617
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  